import { appendIf } from '@btime/helpers'
import { assoc, compose, pick } from 'ramda'
import { gql, useMutation } from '@apollo/client'
import { useTranslation } from 'react-i18next'

import { formatApiDate } from '../../../../utils/helpers/date'
import { sessionsClient } from '../../../../utils/apollo/api'
import { useCloseModal } from '../../../../components/modals/ModalsContext'

const MUTATION = gql`
  mutation UpsertPublicToken($input: PublicTokenInput) {
    upsertPublicToken(input: $input) {
      id
    }
  }
`

const cleanRequest = form => {
  return compose(
    pick(['id', 'name', 'type', 'action', 'amountLeft', 'expireDate', 'conditions', 'payload']),
    item => assoc('amountLeft', parseInt(item.amountLeft), item),
    item => assoc('expireDate', item.expireDate ? formatApiDate(item.scheduling) : null, item),
    item => assoc('conditions', item.conditions ? JSON.stringify(item.conditions) : null, item),
    item => assoc('payload', item.payload ? JSON.stringify(item.payload) : null, item)
  )(form)
}

const useValidate = () => {
  const { t } = useTranslation('validations')

  return (form, setErrors) => {
    const errors = [
      ...appendIf(!form.action, { path: ['action'], message: t('required') }),
      ...appendIf(!form.name, { path: ['name'], message: t('required') }),
      ...appendIf(!form.type, { path: ['type'], message: t('required') }),
      ...appendIf(form.type === 'rest' && !form.payload, { path: ['payload'], message: t('required') })
    ]

    setErrors(errors)
    return errors.length === 0
  }
}

export const useSavePublicToken = () => {
  const closeModal = useCloseModal()
  const [request, state] = useMutation(MUTATION, { refetchQueries: ['PublicTokens'], client: sessionsClient })
  const validate = useValidate()

  const handleRequest = (form, actions) => {
    const input = cleanRequest(form)
    const { setErrors } = actions
    const isValid = validate(form, setErrors)

    if (isValid) {
      return request({ variables: { input } }).then(resp => {
        if (!resp.errors) {
          closeModal()
        }
      })
    }
  }

  return [handleRequest, state]
}
